import axios from "axios"
import requestCache from "../requestCache"
import { Message,MessageBox  } from 'element-ui'
import {httpCode} from "@/plugins/dictionary";
axios.interceptors.response.use(data => {
    //==============  所有请求完成后都要执行的操作  ==================
    let result=data.data.data,config=data.config;
    if(!data.data.success) {
        if(!config.unAlert){
            MessageBox.alert(data.data.errMessage||httpCode.program, '提示', {
                confirmButtonText: '确定',
            });
        }
        return Promise.reject(data);
    }
    if(config.pipe){
        result = config.pipe(result);
    }
    if(config.useCache){
        requestCache.setItem(config.url.replace(config.baseURL,''),result,config.useCache)
    }
    return result;
}, (err) => {
    if(err&&err.isCache){
        return Promise.resolve(err.value)
    }
    let message,unAlert=err.config?err.config.unAlert:false;
    if(err.response){
        message=httpCode[err.response.status]||httpCode.default;//当这里的状态码不存在时，message就成了undefined
    }else if(err.request){
        message=httpCode.noResponse;
    }else {
        message=err.message||httpCode.program
    }
    if(!unAlert){
        Message.error(message);
    }
    return Promise.reject(err);
});
